import React from "react";

import ProgramStrategyPage from "./program-strategy-page";

const A2AProgramsPage: React.FC = () => (
  <ProgramStrategyPage
    programStrategyType="a2a"
    formId="a2a-programs-form"
    headerTitle="A2A program strategy"
    breadcrumbLabel="A2A"
  />
);

export default A2AProgramsPage;
